// Retool provided this at frontend/lib/shadcn/utils. Ported components import
// `cn` from '../lib/shadcn/utils', so the path is preserved exactly.
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
